<script setup>
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  code: {
    type: String,
    required: true,
  },
});

const insertPixIntoReply = () => {
  emitter.emit(BUS_EVENTS.INSERT_INTO_NORMAL_EDITOR, props.code);
};
</script>

<template>
  <div class="flex flex-col gap-2 p-3 mt-2 rounded-lg bg-n-alpha-2">
    <div class="text-sm font-medium">{{ $t('VISION.PIX_TITLE') }}</div>
    <div class="p-2 font-mono text-xs break-all rounded-md bg-n-alpha-3">
      {{ code }}
    </div>
    <Button
      :label="$t('VISION.PIX_INSERT')"
      faded
      sm
      slate
      icon="i-lucide-message-square-plus"
      @click="insertPixIntoReply"
    />
  </div>
</template>
